import { render, staticRenderFns } from "./VipUser.vue?vue&type=template&id=49289f1c&scoped=true&"
import script from "./VipUser.vue?vue&type=script&lang=js&"
export * from "./VipUser.vue?vue&type=script&lang=js&"
import style0 from "./VipUser.vue?vue&type=style&index=0&id=49289f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49289f1c",
  null
  
)

export default component.exports